/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { NbDatepickerModule, NbDialogModule, NbInputModule, NbMenuModule } from '@nebular/theme';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { KeyValuePipe } from '@angular/common';

import {
  //NbChatModule,
  //NbDatepickerModule,
  //NbDialogModule,
  //NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { LoginComponent } from './masarat/login/login.component';
import { environment } from '../environments/environment';
import { RequestInterceptor } from './masarat/shared/service/request-interceptor.service';
import { HomeComponent } from './masarat/home/home.component';


function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        realm: 'masarat',
        url: environment.iamHost,
        clientId: 'masarat-app',
        
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/keycloak-silent-check-sso.html'
          
      }
    });


}

@NgModule({
  declarations: [AppComponent, LoginComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(), 
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    FormsModule,
    NbInputModule,
    KeycloakAngularModule,
    
  ],
  providers: [
    //KeyValuePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true,
    }
    
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
